// @ngInject
function InvoiceTypesApiService(ResourcesService) {

  var endpoint = 'invoicetypes';

  return {
    getInvoiceTypes: ResourcesService.apiFactory.get(endpoint),
    getInvoiceType: ResourcesService.apiFactory.get(endpoint),
    getLanguages: ResourcesService.apiFactory.get(endpoint + '/languages'),
    createInvoiceType: ResourcesService.apiFactory.create(endpoint, 'InvoiceType'),
    updateInvoiceType: ResourcesService.apiFactory.update(endpoint, 'InvoiceType'),
    deleteInvoiceType: ResourcesService.apiFactory.delete(endpoint, 'InvoiceType'),
    getPrintDocumentTemplates: ResourcesService.apiFactory.get(endpoint + '/printDocumentTemplates')
  };

}

angular
  .module('invoicetypes.api', [])
  .factory('InvoiceTypesApiService', InvoiceTypesApiService);
